import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Box, Typography } from '@mui/material';


const ImageEditor = ({ src, fileName, onUpdate }) => {
    const containerRef = useRef(null);
    const imgRef = useRef(null);
    const [imgNatural, setImgNatural] = useState({ w: 0, h: 0 });

    const computeDisplayRect = useCallback(() => {
        const img = imgRef.current;
        if (!img || !img.naturalWidth) return;
        setImgNatural({ w: img.naturalWidth, h: img.naturalHeight });
    }, []);

    useEffect(() => {
        const obs = new ResizeObserver(computeDisplayRect);
        if (containerRef.current) obs.observe(containerRef.current);
        return () => obs.disconnect();
    }, [computeDisplayRect]);

    return (
        <Box ref={containerRef} sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 0.5, p: 0 }}>
            <img
                ref={imgRef}
                src={src}
                alt={fileName}
                onLoad={computeDisplayRect}
                style={{ display: 'block', maxWidth: '100%', maxHeight: 'calc(100vh - 220px)', objectFit: 'contain' }}
            />
            {imgNatural.w > 0 && (
                <Typography sx={{ fontSize: 9, color: 'var(--text-3)' }}>
                    {imgNatural.w} × {imgNatural.h} px
                </Typography>
            )}
        </Box>
    );
};

export default ImageEditor;
